// const colorScheme = {
//   'Pentapetalae': '#a6cee3', 
//   'Magnoliopsida': '#1f78b4', 
//   'Eukaryota': '#b2df8a', 
//   'Embryophyta': '#33a02c', 
//   'fabids': '#fb9a99', 
//   'Euphyllophyta': '#e31a1c', 
//   'Spermatophyta': '#fdbf6f', 
//   'Tracheophyta': '#ff7f00', 
//   'rosids': '#cab2d6', 
//   'Mesangiospermae': '#6a3d9a'
// }
const treeRadial = (data) => {
  var defaultDepth = 20
  const defaultConfig = {
    tooltip: {
      trigger: 'item',
      triggerOn: 'mousemove',
      formatter: (params)=>{
        let ancestor = Array.from(new Set(params.treeAncestors.map(item => item.name)))
        return ancestor.slice(1,ancestor.length).join('->')
      }
    },
    series: [
      {
        type: 'tree',
        data: [{
          'name': 'plant',
          'children': data}],
        bottom: '14%',
        layout: 'radial',
        symbol: 'emptyCircle',
        symbolSize: 8,
        roam: 'scale',
        itemStyle: {
          color: '#7fbc41'
        },
        lineStyle: {
          width: 2.25,
          curveness: 0.8,
          color: '#dfc27d'
        },
        label: {
          show: false
        },
        leaves: {
          label: {
            fontSize: 10,
            show: true
          }
        },
        labelLayout: {
          hideOverlap: true
        },
        initialTreeDepth: defaultDepth,
        animationEasing: 'quardraticIn',
        animationDurationUpdate: 600,
        emphasis: {
          focus: 'ancestor',
          label: {
            show: true
          }
        }
      },
    ]
  }

  const opt = Object.assign({}, defaultConfig)
  
  return opt
}

export default treeRadial